import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchUserLeaderboard = async (token) => {
  const res = await axios.get(`${baseUrl}/api/participantProfile/user_leaderboard/?portal=${portal}`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}